// extracted by mini-css-extract-plugin
export default {"root":"styles_root__nDJUA","header":"styles_header__uSIrQ","title":"styles_title__-oenv","active":"styles_active__RFfbJ"};